import isEmpty from 'lodash/isEmpty';
import type { Group } from '../types';

export const extractNonEmptyGroup = (source: Group): Omit<Group, 'uuid'> | null => {
  const target: Omit<Group, 'uuid'> = { operator: source.operator };
  let shouldInclude = false;

  if (!isEmpty(source?.demographic_age?.segments)) {
    target.demographic_age = source.demographic_age;
    shouldInclude = true;
  }

  if (!isEmpty(source?.demographic_gender?.segments)) {
    target.demographic_gender = source.demographic_gender;
    shouldInclude = true;
  }

  if (!isEmpty(source?.location?.segments)) {
    target.location = source.location;
    shouldInclude = true;
  }

  if (!isEmpty(source?.direct?.segments)) {
    target.direct = source.direct;
    shouldInclude = true;
  }

  if (!isEmpty(source?.predefined?.segments)) {
    target.predefined = source.predefined;
    shouldInclude = true;
  }

  if (!isEmpty(source?.lookalike?.segments)) {
    target.lookalike = source.lookalike;
    shouldInclude = true;
  }

  const hasRegion = source?.region != null && source.region !== '';

  if (hasRegion) {
    target.region = source.region;
    target.countries = source.countries ?? null;
  }

  return shouldInclude ? target : null;
};
